import { useNavigate } from 'react-router-dom';

import { ROUTES } from '~/pages/Root/constants';
import { AnalyticsEvent, analyticsService } from '~/services/analytics';

declare global {
  interface Window {
    jivo_api?: { open: () => void };
  }
}

/**
 * Opens the DubaiExpress support chat (Jivo). Falls back to the contacts page
 * when the chat widget has not loaded.
 */
export const useSupportChatDE = (source: string) => {
  const navigate = useNavigate();

  const openSupportChat = () => {
    analyticsService.track(AnalyticsEvent.CONTACT_SUPPORT_BUTTON_CLICKED, {
      from: source,
    });
    if (window.jivo_api) {
      window.jivo_api.open();
      return;
    }
    navigate(ROUTES.contacts);
  };

  return { openSupportChat };
};
